@keyframes enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes enterTop {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.root {
  position: fixed;
  z-index: var(--tuna-zIndex-snackbar);
  display: flex;
  left: 8px;
  right: 8px;
  justify-content: center;
  align-items: center;
  animation: enter 200ms ease-out;
}

.bottom {
  bottom: 8px;
}

.top {
  top: 8px;
  animation-name: enterTop;
}

.left {
  justify-content: flex-start;
}

.center {
  justify-content: center;
}

.right {
  justify-content: flex-end;
}

.content {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 16px;
  min-width: 288px;
  max-width: 568px;
  background-color: var(--tuna-palette-grey-800);
  color: var(--tuna-palette-grey-50);
  border-radius: var(--tuna-shape-borderRadius);
  box-shadow:
    0 3px 5px -1px rgba(0, 0, 0, 0.2),
    0 6px 10px rgba(0, 0, 0, 0.14),
    0 1px 18px rgba(0, 0, 0, 0.12);
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-body2-fontSize);
}

@media (prefers-reduced-motion: reduce) {
  .root {
    animation: none !important;
  }
}
